/**
 * Checkout utilities - centralized exports
 */

// Types
export * from './checkout-types';

// Validation
export {
  validateProductForCheckout,
  validateProductBasic,
  validateSellerTrustLevel,
  validateShippingSelection,
  validatePaymentMethod,
  validateGuestAddress,
  validateGuestEmail,
  getGuestAddressMissingFields,
  isProductShippable,
} from './checkout-validation';

// Shipping
export {
  getProviderLogo,
  transformShippingRate,
  transformShippingRates,
  createAddressHash,
  buildAuthenticatedShippingRequest,
  buildGuestShippingRequest,
  getShippingEndpoint,
  isDimensionsError,
  findDefaultAddress,
  getSelectedShippingAmount,
  getSelectedShippingRate,
} from './shipping-service';

// API helpers
export {
  buildAuthenticatedPaymentIntentPayload,
  buildGuestPaymentIntentPayload,
  getListingStatusMessage,
  isSellerSetupError,
  isPaymentSuccessStatus,
  isPaymentRequiresConfirmation,
  buildPurchaseEventData,
  buildBeginCheckoutEventData,
  extractErrorMessage,
} from './checkout-api';
